import request from '@/services/interceptor.js'


export const get_articoliFornitori = par => {
  return request({
    url: '/api/articoli/' + par,
    method: 'get'
  })
};

export const save_qtaArticoliFornitori = par => {
  return request({
    url: '/api/articoli/save',
    method: 'post',
    data: par
  })
};

export const upload_fileQtaArticoliFornitori = par => {
  return request({
    url: '/api/articoli/upload',
    method: 'post',
    data: par,
    noLoadingBar: true
  })
};